import { Grid, Stack } from "@mui/material";
import type { FC } from "react";
import type { DividerTemplate } from "../../email-design/types/email-divider-settings";
import { ConditionalWrapper } from "../../generic/components/conditional-wrapper";
import { HoverBadge } from "../hover-badge";
import type { PreviewProps } from "./types";

export const DividersPreview: FC<PreviewProps> = (props) => {
  const { divider_settings } = props.data;

  return (
    <Stack direction="column" spacing={2} sx={{ width: "100%" }}>
      {divider_settings?.primary && (
        <DividerPreview
          divider={divider_settings.primary}
          label="Primary Divider"
          name="primary_divider"
          {...props}
        />
      )}
      {divider_settings?.secondary && (
        <DividerPreview
          divider={divider_settings.secondary}
          label="Secondary Divider"
          name="secondary_divider"
          {...props}
        />
      )}
    </Stack>
  );
};

const DividerPreview: FC<
  {
    divider: Partial<DividerTemplate>;
    label: string;
    name: string;
  } & PreviewProps
> = ({ divider, label, name, ...props }) => (
  <Grid>
    <ConditionalWrapper
      condition={props.badgeProps !== undefined}
      wrapper={(children) => (
        <HoverBadge badgeContent={label} name={name} {...props.badgeProps}>
          {children}
        </HoverBadge>
      )}
    >
      <hr
        style={{
          border: 0,
          borderTopWidth: divider.width,
          borderTopColor: divider.color,
          borderTopStyle: divider.style,
        }}
      />
    </ConditionalWrapper>
  </Grid>
);
